import { Dimensions4, Dimensions6 } from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const skeleton = css({
  minHeight: '80vh',
  padding: `${Dimensions4} ${Dimensions6}`,
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: Dimensions4,
});

const wrapper = css({
  minHeight: '80vh',
  padding: `${Dimensions4} ${Dimensions6}`,
});

const header = css({
  display: 'flex',
  alignItems: 'center',
  gap: Dimensions4,
  marginBottom: Dimensions6,
});

const editButton = css({
  '&.MuiButton-root': {
    marginLeft: 'auto',
  },
});

const EditTeamMemberStyles = {
  skeleton,
  wrapper,
  header,
  editButton,
};

export default EditTeamMemberStyles;
